import Box from '@mui/material/Box';
import React, { memo } from 'react';

const tagElementStyle = {
  lineHeight: 1,
};

const ListingCardTagComponent = ({ tag }) => <Box sx={tagElementStyle}>{tag}</Box>;

const ListingCardTag = memo(ListingCardTagComponent);
ListingCardTag.displayName = 'Tag';

export default ListingCardTag;
